import { render, staticRenderFns } from "./role-edit.vue?vue&type=template&id=013da2e2&scoped=true"
import script from "./role-edit.vue?vue&type=script&lang=js"
export * from "./role-edit.vue?vue&type=script&lang=js"
import style0 from "./role-edit.vue?vue&type=style&index=0&id=013da2e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013da2e2",
  null
  
)

export default component.exports